import {
  Create,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
  useRedirect,
  required,
} from "react-admin";

import { Typography, Divider } from "@mui/material";

const CategoryCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions, isLoading } = usePermissions();

  // ✅ Wait until permissions are loaded
  if (isLoading) return null;

  // ✅ Now safely check permissions
  if (
    !(
      permissions.includes("assessments.create") ||
      permissions.includes("assessments.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  const handleSuccess = () => {
    notify("Category created successfully 🎉", { type: "success" });
    redirect("/categories");
  };

  return (
    <Create
      title="Create Category"
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      <SimpleForm
        sx={{
          maxWidth: 600,
          mt: 2,
          p: 2,
        }}
      >
        {/* Header */}
        <Typography variant="h6" gutterBottom>
          Create Category
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {(permissions.includes("assessments.create") ||
          permissions.includes("assessments.*") ||
          permissions.includes("*")) && (
          <>
            {/* Category Name */}
            <TextInput
              source="category_name"
              label="Category Name"
              fullWidth
              validate={required()}
            />

            {/* Subcategory Name */}
            <TextInput
              source="subcategory_name"
              label="Subcategory Name"
              fullWidth
              validate={required()}
            />

            {/* Description */}
            <TextInput
              source="description"
              label="Description"
              fullWidth
              multiline
              minRows={3}
            />
          </>
        )}
      </SimpleForm>
    </Create>
  );
};

export default CategoryCreate;